import { render, staticRenderFns } from "./DetailDataSets.vue?vue&type=template&id=6e35ef50&scoped=true"
import script from "./DetailDataSets.vue?vue&type=script&lang=js"
export * from "./DetailDataSets.vue?vue&type=script&lang=js"
import style0 from "./DetailDataSets.vue?vue&type=style&index=0&id=6e35ef50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e35ef50",
  null
  
)

export default component.exports